// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconWarningSiteMessage = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
            <path
                fill="#DAA91C"
                d="M18.3312618,17.9999573 C19.6113045,17.9999573 20.4157816,16.5939509 19.7748787,15.4691596 L11.443649,0.843233182 C10.8035598,-0.280047526 9.19755557,-0.282107457 8.55634744,0.843233182 L0.224880353,15.4691596 C-0.414767986,16.591788 0.386013141,17.9999573 1.66853112,17.9999573 L18.3312618,17.9999573 Z M10.8428258,11.812472 L9.15717064,11.812472 C8.93588433,11.812472 8.75318579,11.6373092 8.7411483,11.4136006 L8.48357998,6.63236199 C8.47055915,6.39069768 8.660548,6.18748542 8.89956842,6.18748542 L11.1003941,6.18748542 C11.3394145,6.18748542 11.5294373,6.39069768 11.5164164,6.63236199 L11.2588481,11.4136006 C11.2468106,11.6373092 11.0641121,11.812472 10.8428258,11.812472 Z M9.99999821,15.6796503 C9.11787079,15.6796503 8.40277623,14.9556187 8.40277623,14.0624666 C8.40277623,13.1693146 9.11787079,12.445283 9.99999821,12.445283 C10.8821256,12.445283 11.5972202,13.1693146 11.5972202,14.0624666 C11.5972202,14.9556187 10.8821256,15.6796503 9.99999821,15.6796503 Z"
            />
        </svg>
    );
};

export default IconWarningSiteMessage;
